"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PridatOsobyProfiluPopup = void 0;
/* eslint-disable react/no-array-index-key */
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../../..");
var Padder_1 = require("../../../../Padder");
var Form_1 = __importDefault(require("../../../Form"));
var PodilejiciOsobaItem_1 = __importDefault(require("./PodilejiciOsobaItem"));
var PridatPodilejiciOsobuPopup_1 = require("./PridatPodilejiciOsobuPopup");
var PridatZpracovatelePopup_1 = require("./PridatZpracovatelePopup");
var WarningDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #f50606;\n  font-size: 16px;\n  font-weight: bold;\n  line-break: 22px;\n  margin: 30px 0;\n"], ["\n  color: #f50606;\n  font-size: 16px;\n  font-weight: bold;\n  line-break: 22px;\n  margin: 30px 0;\n"])));
var PridatOsobyProfiluPopup = function (_a) {
    var znalciList = _a.znalciList, addOsobyProfilu = _a.addOsobyProfilu, selectedKanclUstav = _a.selectedKanclUstav, selectedOsoby = _a.selectedOsoby, onClose = _a.onClose, clenstviLoad = _a.clenstviLoad, primarniIdZkZu = _a.primarniIdZkZu;
    var _b = react_1.useState(selectedOsoby || []), selectedOsobyProfilu = _b[0], setSelectedOsobyProfilu = _b[1];
    var handleChange = function (item) {
        var _a;
        var newValue = {
            clen: selectedKanclUstav === null || selectedKanclUstav === void 0 ? void 0 : selectedKanclUstav.nazev,
            druh: { id: item.typExternisty === null ? __1.PosudkyTypOsoby.FyzickaOsobaPodnikajici : __1.PosudkyTypOsoby.FyzickaOsoba },
            role: {
                id: 
                // eslint-disable-next-line no-nested-ternary
                item.typExternisty === null
                    ? __1.PosudkyRoleOsoby.ZpracovatelZnalecVRamciZKneboZU
                    : PridatZpracovatelePopup_1.getTypExternisty((_a = item.typExternisty) === null || _a === void 0 ? void 0 : _a.id) === __1.PosudkyRoleOsoby.OsobaZapojenaDoVedeckovyzkumneCinnosti
                        ? __1.PosudkyRoleOsoby.ZpracovatelOsobaVedeckovyzkumnaCinnostRamciZKneboZU
                        : __1.PosudkyRoleOsoby.ZpracovatelOsobaNezbytnaOdbornostVRamciZKneboZU,
            },
            jmeno: item.jmeno,
            prijmeni: item.prijmeni,
            adresaPobytu: item.adresaPobytu,
            adresaSidla: item.adresaSidla,
            nazev: item.nazev,
            ico: item.ico,
            datumNarozeni: item.datumNarozeni,
            idSubjekt: item.idSubjektu,
            idExterniOsoba: item.idExternisty,
            podiliSeJakoClen: primarniIdZkZu !== null && primarniIdZkZu !== void 0 ? primarniIdZkZu : selectedKanclUstav === null || selectedKanclUstav === void 0 ? void 0 : selectedKanclUstav.idSubjekt,
            titulPred: item.titulPred,
            titulZa: item.titulZa,
            id: item.idOsoba,
            isOsobaProfilu: true,
            typExternisty: item.typExternisty,
        };
        var aktualni = selectedOsobyProfilu.find(function (po) { return (po === null || po === void 0 ? void 0 : po.idSubjekt) === item.idSubjektu && po.idExterniOsoba === item.idExternisty; });
        if (aktualni)
            setSelectedOsobyProfilu(selectedOsobyProfilu.filter(function (po) { return po !== aktualni; }));
        else
            setSelectedOsobyProfilu(__spreadArrays(selectedOsobyProfilu, [newValue]));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatPodilejiciOsobuPopup_1.PopupChildren, null,
            react_1.default.createElement(Form_1.default, { initialValues: {}, onSubmit: function () { return addOsobyProfilu(selectedOsobyProfilu); } }, function (_a) {
                var isSubmitting = _a.isSubmitting;
                return (react_1.default.createElement(Padder_1.Padder, null,
                    react_1.default.createElement(PridatPodilejiciOsobuPopup_1.StyledDiv, null,
                        react_1.default.createElement("b", null, "Vyberte osobu pod\u00EDlej\u00EDc\u00ED se na zpracov\u00E1n\u00ED posudku")),
                    react_1.default.createElement(PridatPodilejiciOsobuPopup_1.StyledDiv, null, "Zvolte alespo\u0148 jednu osobu pod\u00EDlej\u00EDc\u00ED se na zpracov\u00E1n\u00ED posudku."),
                    (znalciList === null || znalciList === void 0 ? void 0 : znalciList.length) === 0 && !clenstviLoad ? (react_1.default.createElement(WarningDiv, null,
                        "Ve ", "" + ((selectedKanclUstav === null || selectedKanclUstav === void 0 ? void 0 : selectedKanclUstav.druhOsobyNazev) === 'Znalecký ústav' ? 'znaleckém ústavu' : 'znalecké kanceláři'),
                        " nen\u00ED evidov\u00E1na \u017E\u00E1dn\u00E1 osoba podle \u00A7 47 odst. 1 z\u00E1kona \u010D. 254/2019 Sb. Bezodkladn\u011B tyto osoby proka\u017Ete Ministerstvu spravedlnosti.")) : (react_1.default.createElement(PridatPodilejiciOsobuPopup_1.ListWrap, null, !!(znalciList === null || znalciList === void 0 ? void 0 : znalciList.length) &&
                        znalciList.map(function (item, i) { return (react_1.default.createElement(PridatPodilejiciOsobuPopup_1.FlexRow, { key: i },
                            react_1.default.createElement(PodilejiciOsobaItem_1.default, { znalecItem: __assign(__assign({}, item), { podiliSeJakoClen: selectedKanclUstav === null || selectedKanclUstav === void 0 ? void 0 : selectedKanclUstav.idSubjekt }), setSelectedPodilejiciOsoba: handleChange, defaultChecked: selectedOsobyProfilu === null || selectedOsobyProfilu === void 0 ? void 0 : selectedOsobyProfilu.find(function (s) { return ((s === null || s === void 0 ? void 0 : s.idSubjekt) !== null ? (s === null || s === void 0 ? void 0 : s.idSubjekt) === item.idSubjektu : s.idExterniOsoba === item.idExternisty); }) }))); }))),
                    react_1.default.createElement(PridatPodilejiciOsobuPopup_1.CenteredDiv, null, (znalciList === null || znalciList === void 0 ? void 0 : znalciList.length) === 0 ? (react_1.default.createElement(__1.Button, { type: "button", primary: true, name: "zavritOsobyProfiluPopup", onClick: onClose }, "Zav\u0159\u00EDt")) : (react_1.default.createElement(__1.Button, { type: "submit", primary: true, loading: isSubmitting, name: "pridatOsobyProfilu", disabled: selectedOsobyProfilu.length === 0 }, (selectedOsoby === null || selectedOsoby === void 0 ? void 0 : selectedOsoby.length) ? 'UPRAVIT OSOBY' : 'PŘIDAT OSOBY')))));
            }))));
};
exports.PridatOsobyProfiluPopup = PridatOsobyProfiluPopup;
exports.PridatOsobyProfiluPopup.defaultProps = {
    selectedOsoby: undefined,
    primarniIdZkZu: undefined,
};
var templateObject_1;
